import { DEFAULT_TIMEZONE, TIMEZONES } from '@/shared/lib/timezones'

export const resolveTimezone = (timezone?: string | null): string => {
  if (!timezone) {
    return DEFAULT_TIMEZONE
  }

  const trimmed = timezone.trim()
  if (!trimmed) {
    return DEFAULT_TIMEZONE
  }

  const byValue = TIMEZONES.find((item) => item.value === trimmed)
  if (byValue) {
    return byValue.value
  }

  const byLabel = TIMEZONES.find((item) => item.label === trimmed)
  if (byLabel) {
    return byLabel.value
  }

  return DEFAULT_TIMEZONE
}
